/**
 * Specification-step ids enum for automation tests.
 */
export enum SpecFieldTestIds {
  MIX_CODE = 'mix-code',
  MIX = 'mix',
  CONTRACT = 'contract',
  DELIVERY_TIME = 'delivery-time',
  DELIVERY_TIME_FROM = 'delivery-time-from',
  DELIVERY_TIME_TO = 'delivery-time-to',
  PURCHASE_ORDER = 'purchase-order',
  RECEIVING_PERSON = 'receiving-person',
  PART_LOAD = 'part-load',
  PRODUCT_SELECTION = 'product-selection',
  PRODUCT_DESCRIPTION = 'product-description',
  PRODUCT_COMMERCIAL_DESCRIPTION = 'product-commercial-description',
  PRODUCT_CATALOG = 'product-catalog',
  QUANTITY = 'quantity',
  QUANTITY_REMAINS = 'quantity-remains',
  LOADS_REMAINS = 'loads-remains',
  CARD_BOX = 'card-box',
  GROUP_TRIP_BUTTON = 'group-trip-btn',
  GROUP_TRIP_EDIT_BUTTON = 'group-trip-edit-btn',
  DATE = 'date',
  REQUEST_PICKUP_DATE = 'request-pickup-date',
  DELIVERY_DATE = 'delivery-date',
  TIME = 'time',
  TIME_TO = 'time-to',
  SPACING_TIME = 'spacing-time',
  SPACING_LOADS = 'spacing-loads',
  LOAD_SPACING = 'load-spacing',
  SUNDAY_HOLIDAY_DAY = 'sunday-holiday-day',
  TIME_WINDOWS = 'request-time',
  CONTRACT_ANTICIPATED_INVOICE = 'contract-anticipated-invoice',
  PURCHASE_ORDER_CHECKBOX = 'purchase-order-checkbox',
  PURCHASE_ORDERS = 'purchase-orders',
  PURCHASE_ORDERS_BUTTON = 'purchase-orders-button',
  PURCHASE_ORDER_INFO = 'purchase-order-info',
  PROGRAMMED_DATE = 'programmed-date',
  REQUEST_DATE = 'request-date',
  REQUEST_TIME = 'request-time',
  REQUESTED_DATE = 'requested-date',
  REQUESTED_TIME = 'requested-time',
  UNIT_DESC = 'unit-desc',
  COUNTER_OFFERS = 'counter-offers',
  COUNTER_OFFERS_TO = 'counter-offers-to',
  COUNTER_OFFERS_DAY = 'counter-offers-day',
  ID = 'id',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  AFTER_CUTOFF_INFO = 'after-cutoff-info',
  CONTRACT_INFORMATIVE = 'contract-informative',
  CONTRACT_SELECT = 'contract-select',
  UNIT = 'unit',
  VALUE_ADDED_FIRST = 'value-added-first',
  VALUE_ADDED_SECOND = 'value-added-second',
  VALUE_ADDED_THIRD = 'value-added-third',
  VALUE_ADDED_FOURTH = 'value-added-fourth',
  CLEAN_UP = 'clean-up',
  SPREAD_BAR = 'spread-bar',
  ASAP = 'asap',
  DUST_BAG = 'dust-bag',
  ADDITIONAL_SERVICES = 'additional-services',
  PROJECT_PROFILES = 'project-profiles',
  UNLOAD_TYPE = 'unload-type',
  PUMP = 'pump',
  PUMP_CAPACITY = 'pump-capacity',
  PIPE_QUANTITY = 'pipe-quantity',
  APPLICATION = 'application',
  APPLICATION_REQ = 'application-req',
  DISCHARGE_TIME = 'discharge-time',
  SPACING = 'spacing',
  SLUMP = 'slump',
  SLUMP_PRODUCT = 'slump-product',
  SLUMP_TYPE = 'slump-type',
  ADDITIONAL_PRODUCTS = 'additional-products',
  LOAD_SIZE = 'load-size',
  ADJUSTMENT = 'adjustment',
  HOSES = 'hoses',
  PUMPABILITY = 'pumpability',
  COLOR_INFO = 'color-info',
  UNLOAD_TIME = 'unload-time',
  PUMP_PRIMER_MIX = 'pump-primer-mix',
  PRIMER_QUANTITY = 'primer-quantity',
  PRIMER_SLUMP = 'primer-slump',
  PRIMER_ARRIVAL_BEFORE_DELIVERY = 'primer-arrival-before-delivery',
  PUMP_PRIMER_PRODUCT = 'pump-primer-product',
  CLEANING_ON_SITE = 'cleaningOnSite',
  PUMP_PRIMER_QUANTITY = 'primer-quantity',
  PUMP_PRIMER_SLUMP = 'primerSlump',
  PUMP_PRIMER_ARRIVAL_BEFORE_DELIVERY = 'primerArrivalBeforeDelivery',
  ADDITIONAL_INFO = 'additional-info',
  RECCURENCE = 'reccurence',
  PAYMENT_TERMS = 'payment-terms',
  PAYMENT_TERMSDESC = 'payment-termsdesc',
  PAYMENT_TYPECODE = 'payment-typecode',
  ORDER_ID = 'order-id',
  JOBSITE_CODE = 'jobsite-code',
  PLANTS = 'plants',
  PLANT = 'plant',
  HAULER = 'hauler',
  FORMAT = 'format',
  DELIVERY_MODE = 'delivery-mode',
  VEHICLE = 'vehicle',
  POINT_OF_DELIVERY = 'point-of-delivery',
  CATALOG = 'catalog',
  VALIDATE_DATE = 'validate-date',
  PROTOTYPE_ADD = 'prototype-add',
  STD_LOD_INFORMATIVE = 'std-lod-informative',
  CEMEXPUMP_REQUIRED_SIZE = 'cemexpump-required-size',
  CEMEXPUMP_ALTERNATIVE_SIZE_TO_MAXIMUM = 'cemexpump-alternative-size-to-maximum',
  CEMEXPUMP_PIPE_LENGTH = 'cemexpump-pipe-length',
  CEMEXPUMP_PIPE_DIAMETER = 'cemexpump-pipe-diameter',
  CEMEXPUMP_COMMENTS = 'cemexpump-comments',
  CEMEXPUMP_POWER_LINE = 'cemexpump-power-line',
  CEMEXPUMP_FALL_PROTECTION = 'cemexpump-fall-protection',
  CEMEXPUMP_CLEANING_ON_SITE = 'cemexpump-cleaning-on-site',
  CEMEXPUMP_PRIMER_BY_CEMEX = 'cemexpump-primer-by-cemex',
  ITEM_SEQ_NUM = 'item-seq-num',
  SCHEDULE_MOMENT = 'schedule-moment',
  WAITING_LIST_MOMENT = 'waiting-list-moment',
  PRODUCT_PUMP_INFORMATIVE = 'product-pump-informative',
  SPECIAL_INSTRUCTION = 'special-instruction',
  SPECIAL_INSTRUCTIONS = 'special-instructions',
  DELIVERY_INSTRUCTIONS = 'delivery-instructions',
  CONCRETE_MIN_QUANTITY_INFO = 'concrete-min-quantity-info',
  SPECIAL_INSTRUCTION_INFORMATIVE = 'special-instruction-informative',
  KICKER = 'kicker',
  MANEUVER = 'maneuver',
  PUMP_LENGTH = 'pump-length',
  LINEAR_METERS = 'linear-meters',
  SAME_DAY_DELIVERY_MESSAGE = 'same-day-delivery-message',
  MIN_WEIGHT_SURCHARGE_WARINING = 'min-weight-surcharge-warning',
  DUST_BAG_WARNING = 'dust-bag-warning',
  UNAVAILABILITY_DISCLAIMER = 'unavailability-disclaimer',
  DELIVERY_TIME_EXTENDED = 'delivery-time-extended',
  BLACKOUT_DAY_DELIVERY_MESSAGE = 'blackout-day-delivery-message',
  ALERT_EXPIRATION_DATE = 'alert-expiration-date',
  TEMPERATURE_LABEL = 'temperature-label',
  TEMPERATURE_NONE_CONDITION = 'temperature-none-condition',
  ICE_LABEL = 'ice-label',
  INFO_TEMPERATURE_MANAGEMENT = 'info-temperature-management',
  TEMPERATURE_UNDER = 'temperature-under',
  TEMPERATURE_UNDER_DISABLED = 'temperature-under-disabled',
  SUMMER_SET = 'summer-set',
  SUMMER_SET_DISABLED = 'summer-set-disabled',
  DECLINE_TEMPERATURE_MANAGEMENT = 'decline-temperature-management',
  ICE_QUANTITY = 'ice-quantity',
  HOLD_QTY = 'HOLD_QTY',
}
